import { Col, Label, Row } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { P } from "../../../../../../AbstractElements";
import { productTagItem } from "../../../../../../Data/Applications/ECommerce/Product";
import { ProductTagProp } from "../../../../../../Types/ECommerce.type";

export default function ProductTag({ title, subTitle }: ProductTagProp) {
  return (
    <Col sm={6}>
      <Row className="product-tag">
        <Col xs={12}>
          <Label>{title}</Label>
        </Col>
        <Col xs={12}>
          <Typeahead labelKey="name" options={productTagItem} multiple clearButton id="selectTwo" defaultSelected={productTagItem.slice(0, 1)} />
          {subTitle && <P>{"Products can be tagged"}</P>}
        </Col>
      </Row>
    </Col>
  );
}
